module.exports = __webpack_public_path__ + "img/categoryPage.06038e4f.jpg";